"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.config = void 0;
var _utils = require("../../../../utils");
/**
 * @private
*/
const color = function () {
  let code = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  code = code.toLowerCase().replace(/\s/, '-');
  switch (code) {
    case 'good':
      return '#29e11f';
    case 'moderate':
      return '#f8f92a';
    case 'usg':
      return '#f9681b';
    case 'unhealthy':
      return '#f60115';
    case 'very-unhealthy':
      return '#7a2c83';
    case 'hazardous':
      return '#65001b';
    default:
      return '#000000';
  }
};
/**
 * @private
*/
const size = function () {
  let code = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  code = code.toLowerCase().replace(/\s/, '-');
  switch (code) {
    case 'moderate':
      return 12;
    case 'usg':
      return 14;
    case 'unhealthy':
      return 18;
    case 'very-unhealthy':
      return 20;
    case 'hazardous':
      return 24;
    default:
      return 10;
  }
};
/**
 * @private
*/
const config = exports.config = {
  data: {
    request: {
      endpoint: 'airquality'
    },
    properties: {
      id: 'id',
      timestamp: 'timestamp'
    }
  },
  style: {
    marker: data => {
      const period = (0, _utils.get)(data, 'periods.0');
      if (!period) {
        return {
          skip: true
        };
      }
      const type = (0, _utils.get)(period, 'category');
      if (!type) {
        return {
          skip: true
        };
      }
      const width = size(type);
      return {
        className: 'marker-airquality',
        svg: {
          shape: {
            type: 'circle',
            fill: {
              color: color(type)
            },
            stroke: {
              color: '#ffffff',
              width: 2
            }
          }
        },
        size: [width, width]
      };
    }
  }
};
var _default = exports.default = config;